// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".network-config-form-f49d5 .network-config-blb-id-wrapper-2d949{position:relative}.network-config-form-f49d5 .network-config-blb-id-wrapper-2d949 .network-config-refresh-2d582{left:425px;position:absolute;top:8px}.network-config-form-f49d5 .network-config-blb-id-wrapper-2d949 .network-config-create-eb02b{left:450px;position:absolute;top:6px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": "network-config-form-f49d5",
	"blb-id-wrapper": "network-config-blb-id-wrapper-2d949",
	"blbIdWrapper": "network-config-blb-id-wrapper-2d949",
	"refresh": "network-config-refresh-2d582",
	"create": "network-config-create-eb02b"
};
export default ___CSS_LOADER_EXPORT___;
